export default "__VITE_ASSET__CxrYsqiP__"